<!--VISTA DESCRIPCION DEL EXTERNAL CONTENT - CONTENIDO EXTERNO -->
<!--PARTE 1 BANNER -->

<div class="mx-auto max-w-7xl w-full pt-[50px] md:pt-6">
  <!-- ===== BANNER ===== -->
  <div class="w-full relative overflow-hidden md:rounded-3xl shadow-2xl"
    style="background: linear-gradient(135deg, #0a192f 0%, #0e1f3a 30%, #162a45 60%, #1b3250 100%);">

    <!-- SVG pattern overlay (izquierda) -->
    <div class="absolute inset-0 overflow-hidden w-3/5">
      <svg class="absolute inset-0 w-full h-full opacity-10" viewBox="0 0 600 400" fill="none" stroke="#00E5FF">
        <g stroke-width="0.5">
          <line x1="50" y1="80" x2="200" y2="150" />
          <line x1="200" y1="150" x2="350" y2="90" />
          <line x1="350" y1="90" x2="500" y2="200" />
          <line x1="100" y1="250" x2="250" y2="180" />
          <line x1="250" y1="180" x2="400" y2="300" />
        </g>
        <g fill="#00E5FF">
          <circle cx="50" cy="80" r="2.5" opacity="0.6" />
          <circle cx="200" cy="150" r="3" opacity="0.8" />
          <circle cx="250" cy="180" r="3.5" opacity="0.9" />
        </g>
      </svg>
      <div class="absolute inset-0 opacity-5"
        style="background-image: radial-gradient(circle, #00E5FF 1px, transparent 1px); background-size: 24px 24px;">
      </div>
    </div>

    <!-- Imagen del curso (derecha, fade desde izquierda) -->
    <div class="absolute right-0 top-0 bottom-0 hidden lg:block w-[48%]"
      [style.background-image]="'url(' + (externalContent?.picture || 'https://static.vecteezy.com/system/resources/previews/000/701/690/non_2x/abstract-polygonal-banner-background-vector.jpg') + ')'"
      style="background-size: cover; background-position: center;     mask-image: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.3) 25%, rgba(0, 0, 0, 0.65) 60%, rgba(0, 0, 0, 0.8) 100%);">
    </div>

    <!-- Imagen del curso - solo móvil, fondo completo con baja opacidad -->
    <div class="absolute inset-0 block lg:hidden opacity-10"
      [style.background-image]="'url(' + (externalContent?.picture || 'https://static.vecteezy.com/system/resources/previews/000/701/690/non_2x/abstract-polygonal-banner-background-vector.jpg') + ')'"
      style="background-size: cover; background-position: center top;">
    </div>

    <!-- Contenido del banner -->
    <div class="relative z-10 px-5 lg:px-10 py-6 lg:py-10 flex flex-col justify-between min-h-[260px] lg:min-h-[340px] gap-4 lg:gap-0">
      <!-- Breadcrumb + tipo -->
      <div class="w-fit flex items-center gap-1.5 text-xs">
        <button type="button" (click)="goBack()" aria-label="Volver atrás"
          class="shrink-0 text-white/70 hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>
        <span class="bg-slate-800/60 px-3 py-1 rounded-full backdrop-blur-sm  text-white/70 whitespace-nowrap">{{ 'api.content-type.course' | translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="w-3 h-3 text-white/40">
          <path d="m9 18 6-6-6-6"></path>
        </svg>
        <span class="text-white/70 whitespace-nowrap max-w-[calc(100vw-8rem)] lg:max-w-[420px] truncate" title="{{ externalContent?.title }}">{{ externalContent?.provider?.name || company?.name }} — {{ externalContent?.title }}</span>
      </div>

      <!-- Título + descripción + progreso -->
      <div class="max-w-2xl flex flex-col justify-center gap-2">
        <h1 class="text-xl lg:text-3xl font-bold text-white leading-tight line-clamp-2">{{ externalContent?.title }}</h1>
        <div class="journey-description">
          <p class="inner-html text-xs lg:text-sm text-white/80 leading-relaxed mb-2 lg:mb-4 line-clamp-2"
            [innerHTML]="externalContent?.description ? (externalContent.description | firstSentence | safe:'html') : ('words.undescribed-content' | translate)">
          </p>
        </div>

        <!-- Stats móvil (usuarios, duración, rating) -->
        <div class="hidden mobile-only-stats items-center gap-3 text-white/80 text-xs flex-wrap mb-1">
          <span class="flex items-center gap-1" *ngIf="externalContent?.subscribedUsers">
            <i class="fas fa-user text-xs"></i>
            {{ externalContent.subscribedUsers }}
          </span>
          <span class="flex items-center gap-1" *ngIf="externalContent?.duration">
            <i class="fa-regular fa-clock text-xs"></i>
            {{ convertSecondsToHoursMinutes(externalContent.duration) }}
          </span>
          <span class="flex items-center gap-1 text-yellow-400" *ngIf="externalContent?.subscribed">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="text-yellow-400">
              <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
            </svg>
            {{ ratingInfo?.avgRating || 0 }}
          </span>
        </div>

        <!-- Barra de progreso -->
        <div class="flex flex-col gap-3 max-w-xl">
          <div class="flex items-center gap-3">
            <div class="flex-1 h-2.5 md:h-2 bg-white/20 rounded-full overflow-hidden">
              <div class="h-full rounded-full bg-progress-gradient" [style.width]="contentProgress + '%'"></div>
            </div>
            <span class="hidden md:inline text-xs text-white/60 whitespace-nowrap">{{ contentProgress }}% {{'words.total-progress' | translate}}</span>
          </div>
          <span class="mobile-only-progress-label text-[10px] text-white/60 uppercase tracking-wider font-semibold">{{ contentProgress }}% {{'words.total-progress' | translate}}</span>
        </div>
        
      </div>

      <!-- CTA + stats desktop -->
      <div class="flex items-center gap-6 flex-wrap">
        <div class="flex items-center md:gap-6 md:flex-wrap w-full lg:w-auto">
          <button
            *ngIf="!(externalContentType === 'bookboon' && externalContent.type === 'audio' && externalContent.subscribed)"
            palette="secondary" [loading]="isButtonLoading" [ngClass]="{'pointer-events-none': isButtonLoading}"
            (click)="subscribeOrAction()"
            class="flex items-center justify-center gap-2 w-full lg:w-auto px-6 py-2.5 lg:py-2 rounded-full bg-white text-gray-800 lg:bg-white/10 lg:text-white hover:bg-white/90 lg:hover:bg-white/20 backdrop-blur-md text-sm font-semibold transition-all">
            {{ (externalContent?.subscribed ? 'words.continue' : 'words.start-enrollment') | translate }}
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="12" cy="12" r="10" stroke-width="1.5"></circle>
              <polygon points="10,8 16,12 10,16" fill="currentColor"></polygon>
            </svg>
          </button>

          <!-- Stats desktop only -->
          <div class="hidden lg:flex items-center gap-4 text-white/80 text-sm flex-wrap">
            <span [tooltip]="'funnel.adoption.signed-up' | translate" class="flex items-center gap-1"
              *ngIf="externalContent?.subscribedUsers">
              <i class="fas fa-user text-xs"></i>
              {{ externalContent.subscribedUsers }}
            </span>
            <span class="flex items-center gap-1" [tooltip]="'studio.create.course.duration' | translate"
              *ngIf="externalContent?.duration">
              <i class="fa-regular fa-clock text-xs"></i>
              {{ convertSecondsToHoursMinutes(externalContent.duration) }}
            </span>
            <span class="flex items-center gap-1 text-yellow-400 opacity-80" [tooltip]="'words.valoration' | translate"
              *ngIf="externalContent?.subscribed">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-4 h-4 text-yellow-400">
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
              </svg>
              {{ ratingInfo?.avgRating || 0 }}
              <span class="text-white/60 text-xs">({{ ratingInfo?.totalRatingsCompact || 0 }} {{'words.valoration' | translate}})</span>
            </span>
          </div>

          <!-- Modal rating (invisible, needed for functionality) -->
          <app-rating-modal #ratingModal (ratingSubmitted)="handleRating($event)"></app-rating-modal>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Aside derecho -->
<div class="mx-auto max-w-7xl w-full md:py-8  flex flex-col lg:flex-row gap-8">

  <div class="flex-1 min-w-0">
    <div class="bg-white md:border md:border-border/60 md:rounded-lg p-6 shadow-sm">
      <h2 class="text-lg font-semibold text-gray-700 mb-3 inline-block relative group cursor-pointer">
        Descripción
        <span
          class="absolute left-0 -bottom-0.5 h-[2px] w-0 bg-secondary transition-all duration-300 ease-out group-hover:w-full"></span>
      </h2>

      <div class="journey-description-summary">
        <p readMore #readMoreEl="readMore" class="inner-html"
          [innerHTML]="externalContent.description ? (externalContent.description | safe:'html') : ('words.undescribed-content' | translate)">
        </p>
      </div>
      <a class="text-gray-400 text-sm cursor-pointer" *ngIf="readMoreEl.overflow" (click)="readMoreEl.toggleExtend()">{{
        'words.read-more.' +
        readMoreEl.extended | translate }} <span><i class="icon icon-arrow-ios-down"
            [class.icon-arrow-ios-up]="readMoreEl.extended"
            [class.icon-arrow-ios-down]="!readMoreEl.extended"></i></span></a>



    </div>
  </div>

  <aside class="w-full lg:w-[300px] shrink-0">
    <!-- Card detalles del curso -->
    <div class="mx-4 md:mx-0  bg-white rounded-xl border border-gray-100 shadow-md overflow-hidden">
      <div class="p-5 flex flex-col gap-3">

        <h4 class="text-lg font-bold text-gray-700">{{'words.course-details' | translate}}</h4>
        <hr class="border-gray-200" />

        <!-- Detalles -->
        <div class="flex flex-col gap-2 text-sm text-gray-500">
          <div class="flex items-center gap-2.5">
            <i class="fa-regular fa-clock text-gray-400"></i>
            <span>{{ convertSecondsToHoursMinutes(externalContent.duration) }} </span>
          </div>
          <div class="flex items-center gap-2.5">
            <i class="fa-solid fa-earth-americas text-gray-400"></i>
            <span>{{ externalContent?.language?.name }}</span>
          </div>
          <div class="flex items-center gap-2.5 md:hidden">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 shrink-0">
              <path d="M12 7v14"></path>
              <path
                d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z">
              </path>
            </svg>
            <span>{{'words.' + externalContent?.contentType | translate}}</span>
          </div>
        </div>

        <!-- Botones CTA -->
        <button
          *ngIf="!(externalContentType === 'bookboon' && externalContent.type === 'audio' && externalContent.subscribed)"
          class="w-full py-2.5 rounded-full text-sm font-semibold bg-primary text-white hover:bg-secondary-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          palette="secondary" [loading]="isButtonLoading" [ngClass]="{'pointer-events-none': isButtonLoading}"
          (click)="subscribeOrAction()">
          <span class="text-sm font-semibold px-2">{{ callToAction }}</span>
        </button>

        <button *ngIf="externalContent.subscribed"
          class="w-full shadow-sm py-2 rounded-full hover:shadow-md text-sm text-gray-600 border border-gray-500 hover:bg-gray-200 transition-colors flex items-center justify-center gap-2 hover:text-gray-700"
          palette="danger" (click)="modalDelete.open(title)">
          {{ "words.unsubscribe" | translate }}
        </button>

        <hr class="border-gray-200" />

        <!-- Acciones: Calificar / Guardar -->
        <div class="flex justify-around pt-1">
          <button *ngIf="externalContent.subscribed" (click)="ratingModal.open(ratingInfo)"
            class="flex flex-col items-center gap-1 text-gray-400 hover:text-yellow-500 text-[10px] uppercase font-bold transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-gray-500">
              <path
                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
              </path>
            </svg>
            <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">{{'words.rate' | translate}}</span>
          </button>
          <div class="w-px bg-gray-200 mx-1" *ngIf="externalContent.subscribed"></div>
          <button (click)="changeLearnLaterContent()"
            class="flex flex-col items-center gap-1 transition-colors text-[10px] uppercase font-bold"
            [ngClass]="saved ? 'text-primary' : 'text-gray-400 hover:text-gray-600'">
            <i class="text-base" [ngClass]="saved ? 'icon icon-bookmark-1' : 'icon icon-bookmark'"></i>
            <span class="text-gray-500 text-[10px] font-medium uppercase tracking-wide">{{ saved ? ('word-saved' | translate) : ('common.save' | translate) }}</span>
          </button>
        </div>

      </div>
    </div>

    <!-- Card proveedor -->
    <div class="mx-4 md:mx-0 mt-4 bg-white rounded-lg border border-border/50 shadow-md p-4 flex items-center gap-3">
      <div
        class="w-12 h-12 rounded-full bg-slate-50 flex items-center justify-center border border-gray-100 shadow-sm overflow-hidden flex-shrink-0">
        <img #extProviderImg *ngIf="getProviderLogoUrl()" [src]="getProviderLogoUrl()" alt="provider logo"
          class="max-w-[80%] max-h-[80%] object-contain"
          (error)="extProviderImg.style.display='none'; extProviderFallback.style.display='flex'">
        <span #extProviderFallback [style.display]="getProviderLogoUrl() ? 'none' : 'flex'"
          class="font-bold text-sm text-slate-400">
          {{ (externalContent?.provider?.name || company?.name || 'G').charAt(0).toUpperCase() }}
        </span>
      </div>
      <div>
        <span class="text-[10px] uppercase font-bold text-gray-700">{{'words.producted-by' | translate}}</span>
        <h5 class="text-sm font-semibold text-gray-800">{{ externalContent?.provider?.name || company?.name }}</h5>
      </div>
    </div>
  </aside>
</div>



<msc-card-manager-modal-delete-subscription #modalDelete [type]="this.externalContent.id"
  (onSave)="deleteContent($event)">
</msc-card-manager-modal-delete-subscription>